var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 3.25001H15.1875L14.8203 2.51954C14.6616 2.20101 14.3363 1.99976 13.9805 2.00001H9.51562C9.16042 1.99865 8.83571 2.20046 8.67968 2.51954L8.31249 3.25001H3.625C3.27982 3.25001 3 3.52983 3 3.87501V5.12501C3 5.47019 3.27982 5.75001 3.625 5.75001H19.875C20.2202 5.75001 20.5 5.47019 20.5 5.12501V3.87501C20.5 3.52983 20.2202 3.25001 19.875 3.25001ZM5.07812 20.2422C5.13999 21.2302 5.95928 22 6.94921 22H16.5508C17.5407 22 18.36 21.2302 18.4219 20.2422L19.25 7.00001H4.25L5.07812 20.2422Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fb5f4182a747e6a82bf111da0f907286.svg";
export { ForwardRef as ReactComponent };